import * as AncillariesWithMilesState from '@ibe/store/states/ancillaries-with-miles.state';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';

export class State extends AncillariesWithMilesState.State { }

const initialState: AncillariesWithMilesState.State = AncillariesWithMilesState.initialState;

export function reducer(state = initialState, action: AncillariesWithMilesActions.Actions): AncillariesWithMilesState.State {

	switch (action.type) {
		case AncillariesWithMilesActions.ActionTypes.PUT_LOADING:
			state = Object.assign({}, state, { loading: action.payload });
			return state;
		case AncillariesWithMilesActions.ActionTypes.PUT_ANCILLARY_TO_PAY:
			state = Object.assign({}, state, { ancillaryToPay: action.payload });
			return state;
		case AncillariesWithMilesActions.ActionTypes.PUT_ADDED_ANCILLARY:
			const aux = state.ancillariesAdded;
			if (aux.length > 0) {
				let exist = false;
				const group = [];
				aux.forEach(item => {
					if (item.name === action.payload.name) {
						exist = true;
						group.push(Object.assign({}, item, { count: item.count + action.payload.count, total: item.total + action.payload.total }));
					} else
						group.push(item);
				});
				if (!exist)
					group.push(action.payload);

				state = Object.assign({}, state, { ancillariesAdded: group });
			} else
				state = Object.assign({}, state, { ancillariesAdded: [...aux, action.payload] });
			return state;
		case AncillariesWithMilesActions.ActionTypes.REMOVE_ADDED_ANCILLARY:
			const oldState = state.ancillariesAdded;
			const newState = [...oldState].filter(value => value.name !== action.payload);
			state = Object.assign({}, state, { ancillariesAdded: [...newState] });
			return state;
		case AncillariesWithMilesActions.ActionTypes.PUT_FLIGHT_MILES_DISCOUNT:
			state = Object.assign({}, state, { milesInFlightDiscount: action.payload });
			return state;
		case AncillariesWithMilesActions.ActionTypes.PUT_PROCESS_ANCILLARY:
			state = Object.assign({}, state, { processAncillary: action.payload });
			return state;
		case AncillariesWithMilesActions.ActionTypes.PUT_ANCILLARY_TOTAl_TO_PAY:
			state = Object.assign({}, state, { ancillaryTotalToPay: action.payload });
			return state;
		case AncillariesWithMilesActions.ActionTypes.PUT_ORIGINAL_BOOKING_COST:
			state = Object.assign({}, state, { originalBookingCost: action.payload });
			return state;
		case AncillariesWithMilesActions.ActionTypes.PUT_DISCOUNTED_BOOKING_COST:
			state = Object.assign({}, state, { discountedBookingCost: action.payload });
			return state;
		case AncillariesWithMilesActions.ActionTypes.RESET:
			state = Object.assign({}, state, initialState);
			return state;
		default:
			return state;
	}
}

export const getLoading = (state: AncillariesWithMilesState.State) => state.loading;
export const getAncillaryToPay = (state: AncillariesWithMilesState.State) => state.ancillaryToPay;
export const getAncillariesAdded = (state: AncillariesWithMilesState.State) => state.ancillariesAdded;
export const ancillaryTotalMilesToSpend = (state: AncillariesWithMilesState.State) => {
	let totalMiles = 0;
	state.ancillariesAdded.forEach(ancillary => {
		totalMiles += ancillary.total;
	});
	return totalMiles;
};

export const ancillariesTotalDiscount = (state: AncillariesWithMilesState.State) => {
	let totalCash = 0;
	state.ancillariesAdded.forEach(ancillary => {
		totalCash += ancillary.discount * ancillary.count;
	});
	return totalCash;
};


// INDRA - only used
export const getMilesInFlightDiscount = (state: AncillariesWithMilesState.State) => state.milesInFlightDiscount;
export const getProcessAncillary = (state: AncillariesWithMilesState.State) => state.processAncillary;
export const getAncillaryTotalToPay = (state: AncillariesWithMilesState.State) => state.ancillaryTotalToPay;
export const totalMilesToSpend = (state: AncillariesWithMilesState.State) => {
	let total = 0;
	total += state.ancillaryTotalToPay ? state.ancillaryTotalToPay.miles : 0;
	total += state.milesInFlightDiscount ? state.milesInFlightDiscount.miles : 0;
	return total;
};

export const getOriginalBookingCost = (state: AncillariesWithMilesState.State) => state.originalBookingCost;
export const getDiscountedBookingCost = (state: AncillariesWithMilesState.State) => state.discountedBookingCost;